import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, YoutubeLogo, MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { useSiteContent } from "@/contexts/SiteContentContext";
import BigSocialBar from "@/components/BigSocialBar";

export default function Footer() {
  const content = useSiteContent();
  const footer = content?.footer || { tagline: "", social: {}, tagline_bottom: "" };
  const contact = content?.contact || { address: "", phone: "", email: "", hours: "" };

  return (
    <>
      <BigSocialBar />
      <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Moto Petsas GP" className="h-14 w-auto" />
          </div>
          <p className="mt-5 text-white/60 leading-relaxed max-w-md">{footer.tagline}</p>
          <div className="mt-6 flex gap-3">
            <a href={footer.social?.instagram || "#"} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram" className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#E50000] hover:text-[#E50000] transition-colors">
              <InstagramLogo size={18} weight="bold" />
            </a>
            <a href={footer.social?.facebook || "#"} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook" className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#E50000] hover:text-[#E50000] transition-colors">
              <FacebookLogo size={18} weight="bold" />
            </a>
            <a href={footer.social?.youtube || "#"} target="_blank" rel="noreferrer" aria-label="Youtube" data-testid="social-youtube" className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#E50000] hover:text-[#E50000] transition-colors">
              <YoutubeLogo size={18} weight="bold" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-overline mb-4">Εξερεύνηση</p>
          <ul className="space-y-3 text-white/70 text-sm">
            <li><Link to="/catalog" className="hover:text-white">Κατάλογος Μηχανών</Link></li>
            <li><Link to="/service" className="hover:text-white">Κλείσε Σέρβις</Link></li>
            <li><Link to="/test-ride" className="hover:text-white">Δοκιμή</Link></li>
            <li><Link to="/about" className="hover:text-white">Το Γκαράζ</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-overline mb-4">Επικοινωνία</p>
          <ul className="space-y-3 text-white/70 text-sm">
            <li className="flex items-start gap-3"><MapPin size={18} className="mt-0.5 text-[#E50000]" weight="bold" /> {contact.address}</li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-[#E50000]" weight="bold" /> {contact.phone}</li>
            <li className="flex items-center gap-3"><EnvelopeSimple size={18} className="text-[#E50000]" weight="bold" /> {contact.email}</li>
          </ul>
          <p className="mt-6 text-xs text-white/40 font-mono">{contact.hours}</p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Moto Petsas GP. Όλα τα δικαιώματα διατηρούνται.</span>
          <span className="font-mono uppercase tracking-widest">{footer.tagline_bottom}</span>
        </div>
      </div>
    </footer>
    </>
  );
}
